import { UserLogged } from "@/models/auth/user-logged.model";
import { UserProfile } from "oidc-client-ts";
import { ComputedRef, UnwrapNestedRefs } from "vue";
import { OidcState, useOidcStore } from "vue3-oidc";




export type State = {
    oidc: ComputedRef<UnwrapNestedRefs<OidcState<UserProfile>>>
    integracao: any
}
export const state: State = {
    oidc: useOidcStore().state,
    integracao: localStorage.getItem("integracao") ? JSON.parse(localStorage.getItem("integracao")!) : {}
};

